/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsSewOutPricingResponse
 */
export interface DigitizingserviceMelcoDigitizingModelsSewOutPricingResponse {
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsSewOutPricingResponse
     */
    digitizing_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsSewOutPricingResponse
     */
    sew_out_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsSewOutPricingResponse
     */
    subtotal?: number;
}

export function DigitizingserviceMelcoDigitizingModelsSewOutPricingResponseFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsSewOutPricingResponse {
    return DigitizingserviceMelcoDigitizingModelsSewOutPricingResponseFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsSewOutPricingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsSewOutPricingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'digitizing_amount': !exists(json, 'digitizing_amount') ? undefined : json['digitizing_amount'],
        'sew_out_amount': !exists(json, 'sew_out_amount') ? undefined : json['sew_out_amount'],
        'subtotal': !exists(json, 'subtotal') ? undefined : json['subtotal'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsSewOutPricingResponseToJSON(value?: DigitizingserviceMelcoDigitizingModelsSewOutPricingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'digitizing_amount': value.digitizing_amount,
        'sew_out_amount': value.sew_out_amount,
        'subtotal': value.subtotal,
    };
}


